import { Horizontal } from '@gravitate-js/excalibrr'
import { Drawer, Spin, Table } from 'antd'
import React from 'react'

import { getHistoryColumns, hiddenColumns } from '../Grid/Columns/ColumnConfig'
import type usePriceHistoryDrawer from './hooks/usePriceHistoryDrawer'

type HistoryDrawer = {
  priceHistoryDrawerHook: ReturnType<typeof usePriceHistoryDrawer>
}

export function PriceHistoryDrawer({ priceHistoryDrawerHook }: HistoryDrawer) {
  const { visible, priceManagementRow, historyRows, isLoading, closeDrawer } = priceHistoryDrawerHook

  if (isLoading) {
    return <Spin />
  }

  return (
    <Drawer title='Price History' placement='bottom' closable height={370} onClose={closeDrawer} visible={visible}>
      <Horizontal className='price-history-header'>
        <Horizontal style={{ flex: 1, alignItems: 'flex-end', paddingLeft: 10 }}>
          <span className='big mr-2'>{priceManagementRow?.product}</span>
          <span className='medium'>{priceManagementRow?.terminal}</span>
        </Horizontal>
        <Horizontal verticalCenter style={{ alignItems: 'flex-end', paddingRight: 10 }}>
          <span className='big mr-2'>{priceManagementRow?.supplier}</span>
          <span style={{ textTransform: 'capitalize' }} className='medium'>
            {priceManagementRow?.price_type}
          </span>
        </Horizontal>
      </Horizontal>
      {priceManagementRow && (
        <Table
          columns={getHistoryColumns(priceManagementRow, hiddenColumns).map((col) => ({ ...col, minWidth: 150 }))}
          pagination={false}
          scroll={{ x: 200 }}
          dataSource={historyRows}
        />
      )}
    </Drawer>
  )
}
